import Vue from 'vue';
import Vuex from 'vuex';

import dossier from './modules/dossier';
import alerte from './modules/alerte';
import system from './modules/system';
import ProgressBar from './modules/progress-bar';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    alerte,
    system,
    ProgressBar,
    dossier,
  },
});
